import { JOB_SOURCES } from './jobSources.js';

/**
 * Per-section default slices. Each key is a JobFilters accordion section; its
 * value is the subset of filter criteria that section owns. "Clear this
 * section" merges the slice back over the live filters; DEFAULT_FILTERS is
 * composed from every slice so the two can never drift apart.
 */
export const SECTION_DEFAULTS = {
    keywords: {
        keywords: [],
        excludeKeywords: [],
        highlight: true,
        searchIn: { title: true, description: true, skills: true },
    },
    jobTerms: {
        hideNoBudget: false,
        onlyHourly: false,
        onlyFixed: false,
        hourlyRate: { min: '', max: '' },
        fixedPrice: { min: '', max: '' },
    },
    clientDetails: {
        clientDetails: {
            paymentVerified: false,
            minSpend: '',
            minHires: '',
            minRating: '',
            minReviews: '',
            preferredLocations: [],
            avoidLocations: [],
            includeNoHistory: true,
        },
    },
    sources: {
        // All origins on by default. Absence of this map = "match every source"
        // (isSourceEnabled), so filters saved before this feature are unaffected.
        sources: Object.fromEntries(JOB_SOURCES.map((s) => [s.id, true])),
    },
};

export const DEFAULT_FILTERS = {
    ...SECTION_DEFAULTS.keywords,
    ...SECTION_DEFAULTS.jobTerms,
    ...SECTION_DEFAULTS.clientDetails,
    ...SECTION_DEFAULTS.sources,
};

/**
 * Has the user narrowed the live view away from defaults? Drives the "Save as
 * filter" affordance — there's nothing worth saving while every criterion still
 * matches DEFAULT_FILTERS. Mirrors the per-section isActive checks in the UI.
 */
export function hasActiveCriteria(f) {
    if (!f) return false;
    const sIn = f.searchIn || {};
    const cd = f.clientDetails || {};
    const sources = f.sources || {};
    return Boolean(
        f.keywords?.length ||
        f.excludeKeywords?.length ||
        f.highlight === false ||
        sIn.title === false || sIn.description === false || sIn.skills === false ||
        f.hideNoBudget || f.onlyHourly || f.onlyFixed ||
        f.hourlyRate?.min || f.hourlyRate?.max ||
        f.fixedPrice?.min || f.fixedPrice?.max ||
        cd.paymentVerified || cd.minSpend || cd.minHires || cd.minRating || cd.minReviews ||
        cd.preferredLocations?.length || cd.avoidLocations?.length ||
        cd.includeNoHistory === false ||
        Object.values(sources).some((v) => v === false)
    );
}
